export const notifications = {
  title: 'Notifications',
  markAsRead: 'Mark as read',
  markAllAsRead: 'Mark all as read',
  noNotifications: 'No notifications',
};